import React, { useContext } from "react";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import UserContext from "../../../context/user_context";
import { pink } from "@mui/material/colors";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import TableSortLabel from "@mui/material/TableSortLabel";
import { makeid, IsOrder } from "../../../helpers/helper_methods";

/*
    RegistryTable Component

    Renders the registry table based on patientData input and registry_columns

    Author: William Brown
    Updated By: 
*/
export default function RegistryTableHeader(props) {
  const {
    fullTable,
    registry_columns,
    handleSelectAllClick,
    order,
    orderBy,
    onRequestSort,
    patientView,
    patientData,
    cart,
  } = props;

  const currentUser = useContext(UserContext);

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  function sortDataFilter(column) {
    if (column.registry_test == null) {
      return column.data_field;
    } else {
      return {
        column: column.registry_test.test.code,
        sort_type: column.sort_type,
      };
    }
  }

  var checked = true;

  patientData.map((pd) => {
    if (pd.episode.orderable_tests == null) return;

    pd.episode.orderable_tests.map((ot) => {
      if (
        cart.findIndex((x) => x.orderable_test_id == ot.id) == -1 &&
        ot.orderable
      ) {
        checked = false;
      }
    });
  });

  var demographicsLength = registry_columns.filter(
    (x) => x.registry_column_type.name == "demographic"
  ).length;

  if (!patientView) {
    demographicsLength++;
  }

  var observationLength = registry_columns.filter(
    (x) => x.registry_test != null && !x.registry_test.orderable
  ).length;

  var orderablesLength = registry_columns.filter(
    (x) => x.registry_test != null && x.registry_test.orderable
  ).length;

  return (
    <TableHead>
      <TableRow>
        <TableCell colSpan={demographicsLength}>Demographics</TableCell>
        {fullTable ? (
          <>
            <TableCell colSpan={observationLength}>Results</TableCell>
            {!patientView ? (
              <TableCell colSpan={orderablesLength}>Orderables</TableCell>
            ) : null}
          </>
        ) : null}
      </TableRow>
      <TableRow>
        <TableCell
          padding={`checkbox`}
          style={
            patientView == true || !IsOrder(currentUser)
              ? { display: "none" }
              : {}
          }
        >
          <FormControlLabel
            aria-label="Check All"
            control={
              <Checkbox
                checked={checked}
                onChange={handleSelectAllClick}
                sx={{
                  "&.Mui-checked": {
                    color: pink[`A400`],
                  },
                }}
              />
            }
          />
        </TableCell>
        {registry_columns
          .sort((a, b) => {
            return a.order - b.order;
          })
          .map((column) => {
            if (fullTable || (!fullTable && column.registry_test == null)) {
              var className = "";

              if (
                column.registry_test != null &&
                column.registry_test.editable
              ) {
                className = "wide-column";
              } else {
                className = "normal-column";
              }

              if (
                column.registry_test != null &&
                column.registry_test.orderable &&
                patientView != undefined &&
                patientView
              ) {
                return null;
              }
              var sortDirection = "";
              if (
                column.registry_test !== null &&
                column.sort_type !== null &&
                column.sort_type !== ""
              ) {
                sortDirection =
                  orderBy == column.registry_test.test.code ? order : "asc";
              } else {
                sortDirection = orderBy === column.data_field ? order : "asc";
              }

              return (
                <TableCell
                  className={className}
                  key={makeid(15)}
                  sortDirection={orderBy == column.data_field ? order : false}
                >
                  {column.registry_test == null ||
                  (column.sort_type !== null && column.sort_type !== "") ? (
                    <TableSortLabel
                      active={
                        orderBy === column.data_field ||
                        (column.registry_test !== null &&
                          column.sort_type !== null &&
                          column.sort_type !== "" &&
                          orderBy === column.registry_test.test.code)
                      }
                      direction={sortDirection}
                      onClick={createSortHandler(sortDataFilter(column))}
                    >
                      {column.registry_test != null &&
                      !(
                        column.sort_type !== null && column.sort_type !== ""
                      ) ? (
                        <>
                          <Checkbox
                            indeterminate={false}
                            sx={{
                              "&.Mui-checked": {
                                color: pink[`A400`],
                              },
                            }}
                          />
                          {column.name}
                        </>
                      ) : (
                        column.name
                      )}
                    </TableSortLabel>
                  ) : (
                    <>{column.name}</>
                  )}
                </TableCell>
              );
            }
          })}
      </TableRow>
    </TableHead>
  );
}
